import { render } from "./Actions.vue?vue&type=template&id=3eca8b71"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Actions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eca8b71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eca8b71', __exports__)) {
    console.log('reload')
    api.reload('3eca8b71', __exports__)
  }
  
  module.hot.accept("./Actions.vue?vue&type=template&id=3eca8b71", () => {
    console.log('re-render')
    api.rerender('3eca8b71', render)
  })

}


export default __exports__